export const AccountStatusConfig = {
    columns:[
        {headerName:"User ID",mappedValue:"loginId"},
        {headerName:"User Name",mappedValue:"name"},
        {headerName:"Role",mappedValue:"designation"}
    ],
    Actions:[
        "Status"
    ]
}